import React, {useState, useEffect} from 'react';
import md5 from 'blueimp-md5';
import {Modal} from 'antd';
import 'antd/lib/modal/style/css';
import Icon from './../basic-icon';
import './index.less';

import * as Api from './../../api';

const baseKaptchaURL = Api.baseUrl +'kaptcha';

// const defaultKaptchaURL =  baseKaptchaURL +'?v='+ Math.random();

export default (props) => {
    const ref = React.useRef();
    const [domain, setDomain] = useState({});
    const [disabled, setDisabled] = useState(true);

    const defaultKaptchaURL = props.defaultKaptchaURL

    const [compare, setCompare] = useState({
        username: {error: true, message: ""}, 
        password: {error: true, message: ""}, 
        kaptcha: {error: true, message: ""}
    });

    const compareToUsername = (value) => {
        if(value.length === 0) {
            setCompare(Object.assign({}, compare, {
                username: { error: true, message: "请输入用户名！"}
            }));
            setDisabled(true);

        } else if(value.length < 5) {
            setCompare(Object.assign({}, compare, {
                username: { error: true, message: "用户名必须大于等于5位数！"}
            }));
            setDisabled(true);

        } else {
            setCompare(Object.assign({}, compare, {
                username: { error: false, message: ""}
            }));

            setDomain(Object.assign({}, domain, {
                userName: value
            }));

            compareToSome(['password', 'kaptcha']);
        }
    }

    const compareToPassword = (value) => {
        if(value.length < 6 || value.length > 20) {
            setCompare(Object.assign({}, compare, {
                password: { error: true, message: "请输入6-20位密码，区分大小写，不能使用空格！"}
            }));
            setDisabled(true);

        } else {
            setCompare(Object.assign({}, compare, {
                password: { error: false, message: ""}
            }));

            setDomain(Object.assign({}, domain, {
                pwd: md5(value)
            }));

            compareToSome(['username', 'kaptcha']);
        }
    }

    const compareToKaptcha = (value) => {
        if(value.length !== 4) {
            setCompare(Object.assign({}, compare, {
                kaptcha: { error: true, message: "请输入4位数验证码，不区分大小写！"}
            }));
            setDisabled(true);
        } else {
            setCompare(Object.assign({}, compare, {
                kaptcha: { error: false, message: ""}
            }));

            setDomain(Object.assign({}, domain, {
                kaptcha: value
            }));

            compareToSome(['username', 'password']);
        }
    }

    const compareToSome = (rules) => {
        var flag = false;
        for(var i = 0; i < rules.length; i++) {
            const key = rules[i];
            if(compare[key].error) {
                flag = true;
                break;
            }
        }
        setDisabled(flag);
    }

    const setKaptcha = () => {
        ref.current.src = baseKaptchaURL + "?v="+Math.random()
    }

    const onFinish = () => {
        setDisabled(true);
        Api.login(domain).then(response => {
            setDisabled(false);
            props.setAccount(response);
            props.setLoginModalVisiable(false);
            // Modal.success({
            //     title: '登录成功',
            //     content: (
            //         <div>
            //         <p>账号登录成功！</p>
            //         </div>
            //     ),
            //     okText:"确认",
            //     onOk: () => {
            //         props.setAccount(response);
            //         props.setLoginModalVisiable(false);
            //     },
            // });
        }).catch(error => {
            setDisabled(false);
            Modal.error({
                title: '错误信息',
                content: (
                    <div>
                    <p>{error.message}</p>
                    </div>
                ),
                okText:"确认",
                onOk: () => {
                    //props.setAccount(null);
                },
            });
        });
    }


    return (
        <>
        <div className="modal">
            <div className="container">
                <form onSubmit={(event)=>{
                    onFinish();
                    event.preventDefault();
                }}>
                    <h2>登录 <Icon type="icon-close" onClick={() => {
                        props.setLoginModalVisiable(false);
                    }}></Icon></h2>
                    <div className="form-item">
                        <input type="text" placeholder="用户名" 
                        onChange={(event)=>{
                            compareToUsername(event.target.value);
                        }}></input>
                        {compare.username.error ? <div className="error">{compare.username.message}</div> : ""}
                    </div>

                    <div className="form-item">
                        <input type="password" placeholder="密码" 
                        onChange={(event)=>{
                            compareToPassword(event.target.value);
                        }}></input>
                        
                        {compare.password.error ? <div className="error">{compare.password.message}</div> : ""}
                    </div>

                    <div className="form-item">
                        <input type="text" placeholder="验证码" maxLength="4" className="kaptcha"
                        onChange={(event)=>{
                            compareToKaptcha(event.target.value);
                        }}></input>
                        <span className="kaptcha">
                            <img ref={ref} src={defaultKaptchaURL}></img>
                            <span onClick={() => {
                                setKaptcha();
                            }}>换一张</span>
                        </span>
                        {compare.kaptcha.error ? <div className="error">{compare.kaptcha.message}</div> : ""}
                    </div>
                    <div className="form-item">
                        <button type="submit" className={disabled ? 'disabled': 'enabled'} disabled={disabled}>登录</button>
                    </div>
                </form>
            </div>
            
        </div>
        <div className="modal-mask"></div>
        </>
    );
}